<template>
  <div class="status-and-history">
    <div
      class="status-and-tariff-wrapper"
      :class="{
        'status-and-tariff-wrapper--with-date': contractStatus == 'service',
      }"
    >
      <div class="status">
        <div class="status__prop">Статус договора</div>
        <div
          :class="['status__value', `status__value--status--${contractStatus}`]"
        >
          {{ statusName }}
        </div>
      </div>

      <!-- contract starting date are used here instead of 'signing date' -->
      <div v-if="contractStatus == 'service'" class="date">
        <div class="date__prop">Дата заключения:</div>
        <div class="date__value">{{ contractStartDate | localDate }}</div>
      </div>

      <div class="tariff">
        <div class="tariff__prop">Тариф</div>
        <div class="tariff__value">{{ contractTariffName }}</div>
      </div>
    </div>

    <div class="history" @click="toggleContractHistory">
      <img src="@icons/history.svg" alt="history.svg" class="history__icon" />

      <div class="history__text">История действий</div>

      <FadeTransaction>
        <ContractHistory v-if="contractHistoryIsOpen" class="history__box" />
      </FadeTransaction>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { CONTRACT_STATUS_NAMES } from "../../utils/constants";

import ContractHistory from "./ContractHistory.vue";
import FadeTransaction from "../transitions/Fade.vue";

export default {
  name: "ContractOfferStatusAndHistory",

  components: {
    ContractHistory,
    FadeTransaction,
  },

  data() {
    return {
      contractHistoryIsOpen: false,
    };
  },

  computed: {
    ...mapGetters("Organizations/ActiveOne", [
      "contractStatus",
      "contractTariffName",
      "contractStartDate",
    ]),

    statusName() {
      return CONTRACT_STATUS_NAMES[this.contractStatus];
    },
  },

  methods: {
    toggleContractHistory() {
      this.contractHistoryIsOpen = !this.contractHistoryIsOpen;
    },
  },
};
</script>

<style scoped lang="scss">
.status-and-history {
  display: flex;
  align-items: center;
}

.status-and-tariff-wrapper {
  display: flex;

  @media (max-width: 960px) {
    flex-direction: column;
  }
}

.date,
.status,
.tariff {
  display: flex;
  width: fit-content;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 60px;

  &__prop {
    margin-right: 16px;
    color: $grey-400;
    font-size: 13px;
    white-space: nowrap;
  }

  &__value {
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
  }

  .status-and-tariff-wrapper--with-date & {
    @media (max-width: 960px) {
      padding: 10px 0;
      margin-right: 32px;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }
    }
  }

  @media (max-width: 1904px) {
    margin-right: 40px;
  }
}

.status {
  &__value {
    &--status {
      &--service {
        color: $lime-500;
      }

      &--concluding,
      &--terminated {
        color: $red-500;
      }

      &--suspended {
        color: #ff9416;
      }
    }
  }

  @media (max-width: 600px) {
    margin-bottom: 10px;
  }
}

.history {
  position: relative;
  display: flex;
  width: 22%;
  max-width: 160px;
  flex: 1;
  align-items: center;
  margin-left: auto;
  cursor: pointer;

  &__icon {
    width: 16px;
    margin-right: 8px;
  }

  &__text {
    @include ellipsis;

    color: $grey-400;
    white-space: nowrap;
  }

  &__box {
    position: absolute;
    z-index: 1;
    top: calc(100% + 10px);
    right: 0;
    min-width: 280px;
    padding: 20px 20px 0;
    border-radius: 8px;
    background: white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  }
}

@media (max-width: 1904px) {
  .history {
    align-self: flex-start;
  }
}

@media (max-width: 600px) {
  .status,
  .date,
  .tariff {
    flex-direction: column;
    align-items: flex-start;
  }

  .history {
    align-self: flex-start;
  }
}
</style>
